import { Menu, type MenuGroupProps, Text } from "@overmap-ai/blocks"
import type { IssueType, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { IssueTypeIcon } from "../Icons/IssueTypeIcon"

export interface IssueTypeGroupProps extends MenuGroupProps {
	issueTypes: Stored<IssueType>[]
	onSelectIssueType: (issueType: Stored<IssueType>) => void
}

export const IssueTypeGroup = memo<IssueTypeGroupProps>((props) => {
	const { ref, issueTypes, onSelectIssueType, ...rest } = props
	return (
		<Menu.Group ref={ref} {...rest}>
			{issueTypes.map((issueType) => (
				<Menu.Item key={issueType.uuid} onSelect={() => onSelectIssueType(issueType)}>
					<IssueTypeIcon issueTypeId={issueType.uuid} inline />
					<Text className="truncate">{issueType.name}</Text>
				</Menu.Item>
			))}
		</Menu.Group>
	)
})
IssueTypeGroup.displayName = "IssueTypeGroup"
